import { formValueSelector } from 'redux-form';
export const messengerAppearanceFormName = 'dixa-messenger-widget-settings';
export const messengerSettingsFormValueSelector = formValueSelector(messengerAppearanceFormName);
